var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page"},[_c('LoginModal',{attrs:{"customClass":'loginPageModal',"isShow":true,"isHideQrCode":true,"onLoginSuccessHandler":_vm.onLoginSuccessHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }